import * as yup from 'yup';
import { translate } from '../../../i18n/I18nProvider';

export default function() {
  return yup.object().shape({
    name: yup.string().required(translate('AUTH.VALIDATION.REQUIRED_FIELD')),
    context: yup.string().required(translate('AUTH.VALIDATION.REQUIRED_FIELD'))
  });
}
